export const NAVIGATION_ID_STORAGE_KEY = 'com.grafana.faro.lastNavigationId';
